import { createAction, props } from '@ngrx/store';
import { PredictionsState } from '@redux/reducers/predictions.reducer';

export const fullUpdatePredictions = createAction(
  '[Predictions] Full update',
  props<{ newPredictionsState: PredictionsState }>()
);
